<template>
  <div class="container">
    <!-- <div class="search">
      <div class="box">
        <input type="text" class="search_box" placeholder="请输入你想输入的素材">
        <img class="search_icon" :src='searchImg' alt="">
      </div>
    </div> -->
    <div style="height:8px;background:#fff"></div>
    <div class="news">
      <!-- <img class="back_icon" :src='backImg' alt=""> -->
      <div class="user">
        <!-- <img class="user_icon" :src='backImg' alt=""> -->
        <img class="user_icon" :src='$store.state.headimgurl' alt="">
        <div class="user_right">
            <div class="font">{{$store.state.nickname}}</div>
            <!-- <div class="font">神奇小姨妈</div> -->
            <div class="font1">已学<span class="numStyle">{{getStudyDetails.self_article_num}}</span>条/<span class="numStyle">{{getStudyDetails.all_article_num}}</span>条干货</div>
            <div class="font1">已学<span class="numStyle">{{getStudyDetails.self_course_num}}</span>门/<span class="numStyle">{{getStudyDetails.all_course_num}}</span>门课程</div>
        </div>
      </div>  
    </div>
    <div class="box">
        <input type="text" class="search_box" v-model="title" @click="search" placeholder="请输入你想搜索的关键字">
        <img class="search_icon" @click="search" :src='searchImg' alt="">
      </div>
    <div class="postor">
      <!-- <img :src="postImg" alt="" class="poster_icon"> -->
      <div class="poster_icon">
          <mt-swipe :auto="4000">
            <mt-swipe-item v-for="(it,id) in getBanner" :key="id"><img :src="it.img_url" alt="" @click="jumpBanner(it)" class="poster_icon1"></mt-swipe-item>
        </mt-swipe>
      </div>

    </div>

    <div class="sort">
      <div class="sort_line">
        <div class="sort_item" v-for="(item,index) in List1" @click="classify(item)" :key="index">
          <img class="item_icon" :src='item.img_url' alt="">
          <div :class="[classify_id==item.id?'font4':'font2']">{{item.name}}</div>
        </div>
        
      </div>
      <div class="sort_line">
        <div class="sort_item" v-for="(item,index) in List2" @click="classify(item)" :key="index">
          <img class="item_icon" :src='item.img_url' alt="">
          <div :class="[classify_id==item.id?'font4':'font2']">{{item.name}}</div>
        </div>
        <!-- <div class="sort_item"  v-for="(item,index) in getClassify.slice(5,9)" @click="classify(item.id)" :key="index">
          <img class="item_icon" :src='item.img_url' alt="">
          <div :class="[classify_id==item.id?'font4':'font2']">{{item.name}}</div>
        </div> -->
        <!-- <div class="sort_item" v-if="getClassify.length>10">
          <img class="item_icon1" :src='moreImg' alt="">
          <div class="font2">其他分类</div>
        </div> -->
        <!-- <div class="sort_item">
          <img class="item_icon" @click="question" :src='itemImg' alt="">
          <div class="font2">提问</div>
        </div>
        <div class="sort_item">
          <img class="item_icon" @click="active" :src='itemImg' alt="">
          <div class="font2">活动</div>
        </div> -->
      </div>
    </div>
    
    <div class="content">
      <div :class="[all_sort==0?'tit':'tit1']" @click="allsort">全部干货</div>
      <div class="sort1">
        <div :class="[time_sort==0?'font5':'font6']" style="margin-right:18px" @click="timesort">按上架时间</div>
        <div :class="[hot_sort==0?'font5':'font6']" @click="hotsort">按热度</div>
      </div>
      <div class="content_box" v-for="(i,idx) in getArticle" :key="idx" @click="indexDetail(i.id)">
        <div class="content_box_tit">{{i.title}}</div>
        <div class="content_box_text">
          <div class="content_box_text_left">
            <div class="left_say">
                <img class="left_say_icon" :src='userImg' alt="">
                <div class="font3">小姨妈说</div>
            </div>
            <div class="left_text">{{i.desc}}</div>
            <div class="font_style">{{i.order_num}}人已学</div>
          </div>
          <div class="content_box_text_right">
            <img class="right_icon" :src='i.img_url' alt="">
          </div>
          
        </div>
        
      </div>
      
      
     
    </div>
    <div class="bottom">
        <div class="bottom_item">
          <img class="bottom_icon" :src='ghImg' alt="">
          <!-- <div class="bottom_text">小干货</div> -->
          <div class="bottom_text_chose">小干货</div>
        </div>
        <div class="bottom_item" @click="toKc()">
          <img class="bottom_icon" :src='kcImg' alt="">
          <div class="bottom_text">课程</div>
        </div> 
        <div class="bottom_item" @click="toMy()">
          <img class="bottom_icon"  :src='mineImg' alt="">
          <div class="bottom_text">我的</div>
        </div>
    </div>

    <div class="mask" v-if="mask" @click="ismask">
      <div class="mask_box">
        <!-- <img class="close" @click="ismask" :src="closesrc" alt=""> -->
        <img class="lwImg" :src="a1Src" alt="">
        <img class="fontImg" :src="a2Src" alt="">
        <img class="btnImg"  @click="mylabel" :src="a4Src" alt="">
        <img class="closeImg" :src="a3Src" alt="">
        <!-- <div style="height:30px"></div> -->
          <!-- <h1 style="text-align: center;color:#fff;">太好啦~</h1> -->
          <!-- <div class="mask_text">害，你来啦！</div>
          <div class="mask_text">小姨妈送你一条贼干的干货！</div> -->
          <!-- <div class="lw_box">
            <img class="lw" :src="lwsrc" alt="">
          </div> -->
          
          <!-- <div class="mask_button" @click="mylabel">领取</div> -->
      </div>
    </div>
  </div>
</template>
<style scoped>
input::-webkit-input-placeholder { 
/* WebKit browsers */ 
color: rgb(132,132,132); 
} 
input:-moz-placeholder { 
/* Mozilla Firefox 4 to 18 */ 
color: rgb(132,132,132); 
} 
input::-moz-placeholder { 
/* Mozilla Firefox 19+ */ 
color: rgb(132,132,132); 
} 
input:-ms-input-placeholder { 
/* Internet Explorer 10+ */ 
color: rgb(132,132,132); 
}
.lwImg{
  width: 100px;
  height: 100px;
  position: absolute;
  left: calc(50% - 50px);
  top:-50px;
}
.fontImg{
  width: 100%;
  margin-top: 80px;
}
.btnImg{
  width: 100px;
  margin-top: 50px;
  margin-bottom: 50px;
}
.closeImg{
  width: 40px;
  height: 40px;
  bottom: -60px;
  position: absolute;
  left: calc(50% - 20px);
}
.numStyle{
  color: rgb(34,34,34);
  margin-left: 2px;
  margin-right: 2px;
}
.mask{
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.3);
  position: fixed;
  top: 0;
  left: 0;
}
.mask_box{
  width: calc(100vw - 60px);
  background-color :#B3212D;
  position: relative;
  left: 30px;
  top: 40%;
  transform: translateY(-50%);
  border-radius: 5px;
  text-align: center;
}
.close{
    width: 35px;
    height: 35px;
    position: absolute;
    top: -14px;
    right: -14px;
    border-radius: 35px;
    background-color: #fff;
    border:0;
}
.lw_box{
  text-align: center;
  margin-top: 25px;
}
.lw{
  width: 100px;
  height: 100px;
}
.mask_text{
  color:#fff;
  font-size: 16px;
  padding-left: 30px;
  box-sizing: border-box;
  line-height: 30px;
  padding-top: 2px;
}
.mask_button{
    width: 200px;
    height: 42px;
    line-height: 42px;
    background-color:  #fff;
    color: #B3212D;
    font-size: 20px;
    text-align: center;
    margin-top: 30px;
    /* margin-bottom: 30px; */
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 30px;
   box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
   letter-spacing: 2px;
   
}
.container{
  overflow-y: scroll;
  /* font-family:Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei"; */
  color: rgb(34,34,34);
  background-color: #fff;
}
.search{
  width: 100%;
  height: 56px;
  background-color:#B3212D;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10
}
.box{
  position: relative;
  height: 42px;
  background-color:#fff;
}
.search_box{
  -web-kit-appearance:none;
  -moz-appearance: none;
  width: calc(100% - 40px);
  height: 32px;
  line-height: 32px;
  top: 7px;
  left: 20px;
  position: relative;
  display: flex;
  background-color: rgb(244,244,244);
  border-radius: 16px;
  border-width: 0px;
  border-color: #dddddd;
  flex-direction: row;
  align-items: center;
  outline: 0;
  font-size: 14px;
  padding-left: 40px;
  box-sizing: border-box;
  color:rgb(34,34,34)
}
.search_icon{
  width: 16px;
  height: 16px;
  position: absolute;
  top: 15px;
  left: 33px;
}
.back_icon{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.news{
  width: 100%;
  height: 65px;
  position: relative;
  /* margin-top: 56px; */
}
.user{
  width: 100%;
  height: 65px;
  display: flex;
  position: absolute;
  background-color:#fff;
}
.user_right{
  margin-left: 12px;
  justify-content: center;
  display: flex;
  flex-direction: column;
}
.user_icon{
  width: 53px;
  height:53px;
  margin-left: 20px;
  margin-top: 6.5px;
  border-radius: 50%;
}
.font{
  font-size: 14px;
  /* color: #B3212D; */
  color: rgb(34,34,34);
  font-weight: 800;
  margin-bottom: 5px;
  /* letter-spacing: 1px; */
  font-family: 宋体;
}
.font1{
  font-size: 10px;
  color:#696969;
  margin-bottom: 2px;
  letter-spacing: 1px;
  font-weight: bold;
}
.sort{
  width:100%;
  height: 148px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
}
.sort_line{
  flex:1;
  display: flex;
  flex-direction: row;
}
.sort_item{
  min-width: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.item_icon{
  width: 40px;
  height: 40px;
  border-radius: 40px;
  margin-bottom: 10px;
}
.item_icon1{
  width: 40px;
  height: 40px;
  border-radius: 40px;
  margin-bottom:10px;
}
.font2{
  font-size: 12px;
  /* color: rgb(34,34,34); */
  color: #2E2E2E;
  /* font-weight: bold; */
  /* letter-spacing: 1px; */
  font-family: 宋体;
}
.font4{
  font-size: 12px;
  color:#B3212D;
  /* font-weight: bold; */
  font-family: 宋体;
}
.font6{
  font-size: 12px;
  background-color:#B3212D;
  color: #fff;
  padding: 6px 10px;
  border-radius: 20px;
}
.font5{
  font-size: 12px;
  color: rgb(34,34,34);
  padding: 6px 0px;
  border-radius: 20px;
}
.postor{
  width: 100%;
  /* margin-top: 10px; */
  background-color: #fff;
}
.poster_icon{
  width: calc(100% - 40px);
  margin-left: 20px;
  height: 120px;
  padding-bottom: 5px;
  padding-top: 5px;
}
.poster_icon1{
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.content{
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  background-color: #fff;
  box-sizing: border-box;
  margin-bottom: 50px;
}
.tit{
  height: 36px;
  line-height: 36px;
  font-size: 16px;
}
.tit1{
  height: 36px;
  line-height: 36px;
  font-size: 16px;
  color:#B3212D;
}
.sort1{
  /* height: 20px;
  line-height: 20px; */
  font-size: 12px;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 8px;
}
.content_box{
  width: 100%;
  /* height: 140px; */
  background-color: #fff;
  box-sizing: border-box;
  margin-top: 5px;
  border-bottom: 1px solid #e7e7e7;
  padding-top: 8px;
  padding-bottom: 5px;
}
.content_box_tit{
  font-size: 16px;
  font-weight: bold;
  line-height: 26px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.content_box_text{
  display: flex;
  flex-direction: row;
}
.left_say{
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  align-items: center;
  margin-bottom: 10px;
}
.left_say_icon{
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}
.font3{
  font-size: 14px;
  /* color:#696969; */
  color: rgb(34,34,34);
}
.left_text{
    /* color:#696969; */
    color: rgb(34,34,34);
    letter-spacing: 1px;
    font-size: 14px;
    -o-text-overflow: -o-ellipsis-lastline;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 10px;
    line-height: 20px;
}
.content_box_text_left{
  flex: 5;
}
.content_box_text_right{
  flex: 3;
  justify-content: flex-end;
  align-items: center;
  display: flex;
}

.right_icon{
  width: 100px;
  height: 60px;
}
.font_style{
  font-size: 12px;
  color: rgb(123,123,123);
  margin-bottom: 10px;
}
.bottom{
  width: 100%;
  height: 50px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  position: fixed;
  bottom: 0;
  left: 0;
}
.bottom_item{
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.bottom_icon{
  width: 18px;
  height: 18px;
  margin-bottom: 5px;
}
.bottom_text{
  font-size: 14px;
  color: rgb(34,34,34);
}
.bottom_text_chose{
  font-size: 14px;
  color:#B3212D;
}
</style>

<script>
import { getIndex,getSort } from '../apollo/apollo'
import wx from 'weixin-js-sdk';
export default {
   components: {
    
  },
  data() {
    return {
      a1Src:'./static/imgs/a1.png',
      a2Src:'./static/imgs/a6.png',
      a3Src:'./static/imgs/a3.png',
      a4Src:'./static/imgs/a4.png',
      searchImg:'./static/imgs/search.png',
      backImg:'./static/imgs/mybanner.png',
      userImg:'./static/imgs/user.jpg',
      itemImg:'./static/imgs/1.png',
      postImg:'./static/imgs/2.png',
      explainImg:'./static/imgs/3.jpg',
      ghImg:'./static/imgs/ghchose.png',
      kcImg:'./static/imgs/kc.png',
      mineImg:'./static/imgs/mine.png',
      lwsrc:'./static/imgs/xlw.png',
      closesrc:'./static/imgs/closed.png',
      moreImg:'./static/imgs/more.png',
      getIndex:getIndex,
      getSort:getSort,
      getClassify:[],//分类列表
      getArticle:[],//干货列表
      getBanner:[],//轮播图
      getStudyDetails:{},
      getTitle:'',
      classify_id:0,//分类
      time_sort:1,
      hot_sort:0,
      all_sort:0,
      title:"",
      mask:false,
      List1:[],
      List2:[],

    }
  },
  computed:{
    
  },
  created() {
    
  },
  created(){
    
    this.initData()
  },
  methods: {
    active(){
      this.jump('./activeList')
    },
    toKc(){
      this.jump('./course')
    },
    toMy(){
     this.jump('./my')
    },
    indexDetail(i){
      sessionStorage.setItem('article_id',i);
      this.jump('./indexDetail')
    },
    mylabel(){
      this.jump('./mylabel')
    },
    ismask(){
      this.$store.state.status=''
      this.mask=false
    },
    initData() {
      this.$store.state.Authorization=sessionStorage.getItem('Authorization')
      this.$store.state.headimgurl=sessionStorage.getItem('headimgurl')
      this.$store.state.nickname=sessionStorage.getItem('nickname')
      if(this.$store.state.status=='1'){//新用户
        this.mask=true
      }
      getIndex().then(res=>{
        this.getClassify=res.data.getClassify;
        this.getArticle=res.data.getArticle;
        this.getBanner=res.data.getBanner;
        this.getStudyDetails=res.data.getStudyDetails;
        this.getTitle=res.data.getTitle;
        this.$store.state.title=this.getTitle;
        document.title=this.getTitle
        if(this.getClassify.length<=10){
          this.List1=this.getClassify.slice(0,5)
          this.List2=this.getClassify.slice(5,10)
        }else{
          if(this.getClassify.length%10<=5){
            this.List1=this.getClassify.slice(0,this.getClassify.length/2+this.getClassify.length%10)
            this.List2=this.getClassify.slice(this.getClassify.length/2+this.getClassify.length%10,this.getClassify.length)
          }else{
            this.List1=this.getClassify.slice(0,this.getClassify.length/2+5)
            this.List2=this.getClassify.slice(this.getClassify.length/2+5,this.getClassify.length)
          }
        }
        if(sessionStorage.getItem('share')=='2'){//进入活动
          window.location.href="https://screen.xiaoyima.work/index.html?"+"activity_id="+sessionStorage.getItem('activity_id')+"&state=123#/active"
        }
        if(sessionStorage.getItem('share')=='3'){//进入干货详情
          sessionStorage.setItem('share','')
          this.jump('./indexDetail')
        }
        })
        .catch(err=>{
          this.msgManage(err)
        })
    },

    classify(item){
      if(item.name=="活动"){
        this.active()
      }else if(item.name=="提问"){
        this.question()
      }else{
        if(this.classify_id==item.id){
          this.classify_id=0
          this.Sort()
        }else{
          this.classify_id=item.id
          this.all_sort=0
          this.Sort()
        }
      }
      
      
    },
    allsort(){
      this.all_sort=1;
      this.hot_sort=0;
      this.time_sort=0;
      this.title="";
      this.classify_id=0;
      this.Sort()
      
    },
    timesort(){
      this.all_sort=0;
      this.hot_sort=0;
      this.time_sort=1;
      this.Sort()
      
    },
    hotsort(){
      this.all_sort=0;
      this.hot_sort=1;
      this.time_sort=0;
      this.Sort()
     
    },
    search(){
      this.jump('./search')
    },
    Sort(){
      var formDate={
        classify_id:this.classify_id,
        time_sort:this.time_sort,
        hot_sort:this.hot_sort,
        title:this.title
      }
      getSort(formDate).then(res=>{
        this.getArticle=res.data.getArticle
        })
        .catch(err=>{
          this.msgManage(err)
        })
    },
    question(){
      this.showOneBtnAlert('有问题请联系小姨妈微信：xiaoyimawork')
    },
    jumpBanner(it){
      if(it.type=='1'){//干货详情
        sessionStorage.setItem('article_id',it.link_id);
        this.jump('./indexDetail')
      }else if(it.type=='2'){//课程详情
        window.location.href=it.jump_url
      }else if(it.type=='3'){//活动详情
        this.$store.state.isactive='1'
        sessionStorage.setItem('activity_id',it.link_id);
        this.jump('./active')
      }
      // window.location.href=it.jump_url
    }
    


  }, 
  beforeRouteLeave(to, from, next) {
        if(to.path=='/login'){
          wx.closeWindow()
        }
        next()
  },
  destroyed () {  
      
    
  },
  watch:{
    
  }
};
</script>


// WEBPACK FOOTER //
// src/views/index.vue